module.exports = __webpack_public_path__ + "img/laddercontrol2.fad1d7a4.png";